const translations = {
  // Navbar
  'nav.home': 'الرئيسية',
  'nav.services': 'الخدمات',
  'nav.track': 'تتبع الشحنة',
  'nav.about': 'من نحن',
  'nav.contact': 'اتصل بنا',
  'nav.trackNow': 'تتبع الآن',

  // Footer
  'footer.tagline': 'موثوق به من قبل آلاف الشركات حول العالم لتتبع الشحنات الموثوق والآني.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.contactUs': 'تواصل معنا',
  'footer.globalNumbers': 'أرقام عالمية',
  'footer.uk': 'المملكة المتحدة',
  'footer.usa': 'الولايات المتحدة',
  'footer.canada': 'كندا',
  'footer.allRightsReserved': 'جميع الحقوق محفوظة.',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',
  'footer.cookies': 'سياسة ملفات تعريف الارتباط',

  // Hero
  'hero.badge': 'موثوق به من أكثر من 50,000 شركة حول العالم',
  'hero.headline1': 'نُوصل العالم،',
  'hero.headline2': 'في الوقت المحدد',
  'hero.subtext': 'تتبع الشحنات في الوقت الفعلي جواً وبراً وبحراً. اعرف بالضبط أين شحنتك — في كل خطوة من الرحلة.',
  'hero.placeholder': 'أدخل رقم التتبع (مثال: SWT-2024-001847)',
  'hero.trackBtn': 'تتبع الشحنة',
  'hero.tryLabel': 'جرّب:',
  'hero.scroll': 'مرر للاستكشاف',
  'hero.stat1': 'طرود تم تسليمها',
  'hero.stat2': 'دولة نخدمها',
  'hero.stat3': 'معدل الالتزام بالمواعيد',
  'hero.stat4': 'دعم على مدار الساعة',

  // Services Section
  'services.badge': 'مستويات الخدمة',
  'services.title1': 'اختر',
  'services.title2': 'خطة الشحن',
  'services.subtitle': 'من الشحن الاقتصادي إلى الخدمة المميزة في نفس اليوم — لدينا الخدمة المناسبة لكل شحنة.',
  'services.perShipment': 'لكل شحنة',
  'services.monthlyPlan': 'خطة شهرية',
  'services.monthlySaving': 'توفر الخطط الشهرية ما يصل إلى 35% مقارنةً بالأسعار لكل شحنة',
  'services.enterprise.title': 'هل تحتاج خطة مؤسسية مخصصة؟',
  'services.enterprise.desc': 'خصومات على الحجم ومديرو حسابات مخصصون واتفاقيات مستوى خدمة مخصصة للمرسلين عالي التردد.',
  'services.enterprise.cta': 'تواصل مع المبيعات',
  'services.perKg': 'لكل كغ',
  'services.perMo': '/شهر',
  'services.economy.name': 'اقتصادي',
  'services.economy.tagline': 'شحن بتكلفة معقولة',
  'services.economy.cta': 'ابدأ مجاناً',
  'services.economy.time': '5–7 أيام عمل',
  'services.standard.name': 'قياسي',
  'services.standard.tagline': 'توصيل يومي موثوق',
  'services.standard.cta': 'اختر القياسي',
  'services.standard.time': '2–3 أيام عمل',
  'services.express.name': 'سريع',
  'services.express.tagline': 'توصيل معجّل',
  'services.express.cta': 'اختر السريع',
  'services.express.time': 'يوم العمل التالي',
  'services.express.badge': 'الأكثر شيوعاً',
  'services.priority.name': 'أولوية',
  'services.priority.tagline': 'خدمة فاخرة في نفس اليوم',
  'services.priority.cta': 'اختر الأولوية',
  'services.priority.time': 'نفس اليوم (نافذة ساعتين)',
  'services.priority.badge': 'مميز',
  'services.feat.basicTracking': 'تتبع أساسي للطرد',
  'services.feat.emailNotif': 'إشعار التسليم بالبريد الإلكتروني',
  'services.feat.20kg': 'حتى 20 كغ',
  'services.feat.insurance100': 'تأمين قياسي (100 دولار)',
  'services.feat.liveMap': 'تتبع خريطة مباشر',
  'services.feat.priority': 'معالجة ذات أولوية',
  'services.feat.smsAlerts': 'تنبيهات رسائل نصية ودفع',
  'services.feat.signature': 'توقيع عند التسليم',
  'services.feat.fullTracking': 'تتبع كامل في الوقت الفعلي',
  'services.feat.emailSms': 'إشعارات بريد إلكتروني + رسائل نصية',
  'services.feat.50kg': 'حتى 50 كغ',
  'services.feat.insurance500': 'تأمين قياسي (500 دولار)',
  'services.feat.dedicatedDriver': 'سائق مخصص',
  'services.feat.emailSmsPush': 'بريد إلكتروني + رسائل نصية + إشعارات دفع',
  'services.feat.100kg': 'حتى 100 كغ',
  'services.feat.insurance2000': 'تأمين مميز (2,000 دولار)',
  'services.feat.routeOpt': 'تحسين المسار',
  'services.feat.unlimitedWeight': 'وزن غير محدود',
  'services.feat.insurance10000': 'تأمين كامل (10,000 دولار)',
  'services.feat.dedicatedDriverAssigned': 'سائق مخصص معيّن',

  // Tracking Page
  'track.title': 'تتبع شحنتك',
  'track.subtitle': 'أدخل رقم التتبع لمشاهدة الحالة في الوقت الفعلي وتحديثات التسليم.',
  'track.placeholder': 'مثال: SWT-2024-001847',
  'track.scanBtn': 'مسح الرمز',
  'track.trackBtn': 'تتبع',
  'track.privacy': 'رقم تتبعك خاص — فقط أنت تستطيع رؤية تفاصيل شحنتك',
  'track.enter.title': 'أدخل رقم التتبع الخاص بك',
  'track.enter.desc': 'تم إرسال رقم التتبع الفريد إليك بالبريد الإلكتروني عند إنشاء شحنتك. يبدو كـ',
  'track.feature1': 'تحديثات فورية',
  'track.feature2': 'تتبع خريطة مباشر',
  'track.feature3': 'تنبيهات آنية',
  'track.notFound.title': 'لم يتم العثور على شحنة',
  'track.notFound.desc': 'لم نعثر على شحنة برقم التتبع',
  'track.notFound.hint': 'يرجى التحقق من الرقم أو التواصل مع',
  'track.notFound.support': 'الدعم',
  'track.found.title': 'تم العثور على الشحنة',
  'track.found.private': 'خاص بك',
  'track.found.viewDetails': 'عرض التفاصيل الكاملة',
  'track.found.estDelivery': 'التسليم المتوقع',
  'track.found.progress': 'التقدم',

  // About Page
  'about.badge': 'قصتنا',
  'about.headline': 'مبني لعالم التجارة الحديث',
  'about.subtext': 'تأسست SwiftTrack عام 2014 بمهمة بسيطة: جعل الشحن سهلاً كإرسال بريد إلكتروني. اليوم، ننقل ملايين الطرود في أكثر من 180 دولة.',
  'about.stat.founded': 'سنة التأسيس',
  'about.stat.countries': 'دولة نخدمها',
  'about.stat.deliveries': 'عمليات توصيل/سنة',
  'about.stat.partners': 'شركاء تجاريون',
  'about.mission.badge': 'مهمتنا',
  'about.mission.title1': 'ربط الناس،',
  'about.mission.title2': 'توصيل الإمكانيات',
  'about.mission.p1': 'نؤمن بأن كل شحنة تحمل أكثر من مجرد بضائع. تحمل الثقة والعلاقات وعداً بشيء أفضل في الجانب الآخر. تضمن منصتنا التقنية أن كل طرد — من هدية عيد ميلاد مكتوبة بخط اليد إلى جهاز طبي منقذ للحياة — يصل في الوقت والمكان المحددين.',
  'about.mission.p2': 'نجمع بين تتبع GPS المتطور وتحسين المسارات بالذكاء الاصطناعي وشبكة من الناقلين المعتمدين لنقدم لك تجربة شحن الأكثر موثوقية وشفافية في العالم.',
  'about.values.title': 'القيم التي تحركنا',
  'about.values.subtitle': 'ثقافتنا مبنية على أربعة ركائز تُرشد كل قرار نتخذه.',
  'about.value1.title': 'الموثوقية',
  'about.value1.desc': '99.7% من عمليات التسليم في الوقت المحدد مدعومة بالمراقبة الفورية وحل المشكلات بشكل استباقي.',
  'about.value2.title': 'الشفافية',
  'about.value2.desc': 'رؤية كاملة في كل خطوة. لا رسوم خفية، لا مفاجآت — مجرد تواصل صادق وواضح.',
  'about.value3.title': 'الاستدامة',
  'about.value3.desc': 'أسطول تعويض الكربون والتوجيه المحسّن لتقليل بصمتنا البيئية.',
  'about.value4.title': 'العميل أولاً',
  'about.value4.desc': 'كل قرار نتخذه يبدأ بسؤال واحد: كيف يُحسّن هذا الأمور لعملائنا؟',
  'about.team.title1': 'تعرف على',
  'about.team.title2': 'قيادتنا',
  'about.team.subtitle': 'مشغّلون وتقنيون متمرسون يجمعهم شغف بالخدمات اللوجستية العالمية.',

  // Contact Page
  'contact.title': 'تواصل معنا',
  'contact.subtitle': 'أسئلة أو عروض أسعار أو ملاحظات — فريقنا مستعد للمساعدة على مدار الساعة.',
  'contact.info.title': 'نحن هنا من أجلك',
  'contact.info.desc': 'تواصل معنا من خلال أي قناة. متوسط وقت الاستجابة أقل من 3 دقائق للمحادثة المباشرة، وأقل من ساعتين للبريد الإلكتروني.',
  'contact.info.address': 'العنوان',
  'contact.info.phone': 'الهاتف',
  'contact.info.email': 'البريد الإلكتروني',
  'contact.info.hours': 'ساعات الدعم',
  'contact.info.hoursVal': '24/7 — لا نغلق أبداً',
  'contact.form.title': 'أرسل لنا رسالة',
  'contact.form.name': 'الاسم الكامل',
  'contact.form.email': 'عنوان البريد الإلكتروني',
  'contact.form.phone': 'الهاتف',
  'contact.form.subject': 'الموضوع',
  'contact.form.subjectPlaceholder': 'اختر موضوعاً',
  'contact.form.subjectTrack': 'مساعدة في تتبع الشحنة',
  'contact.form.subjectQuote': 'طلب عرض سعر',
  'contact.form.subjectEnterprise': 'حلول المؤسسات',
  'contact.form.subjectBilling': 'استفسار فواتير',
  'contact.form.subjectOther': 'أخرى',
  'contact.form.message': 'الرسالة',
  'contact.form.send': 'إرسال الرسالة',
  'contact.form.sending': 'جارٍ الإرسال...',
  'contact.form.error': 'حدث خطأ ما. يرجى المحاولة مجدداً.',
  'contact.sent.title': 'تم إرسال الرسالة!',
  'contact.sent.desc': 'سنرد عليك خلال ساعتين.',
  'contact.sent.another': 'إرسال رسالة أخرى',
};

export default translations;
